<template>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-12 mt-3">
          <form class="form-horizontal " role="form">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group form-inline d-flex justify-content-center">
                  <label for="start_date" class="control-label mr-3"
                    >Start Date</label
                  >
                  <div class="mr-3">
                    <date-picker
                      v-model="start_date"
                      valueType="format"
                    ></date-picker>
                  </div>
  
                  <label for="end_date" class="control-label mr-3"
                    >End Date</label
                  >
                  <div class="mr-3">
                    <date-picker
                      v-model="end_date"
                      valueType="format"
                    ></date-picker>
                  </div>
                  <b-button
                    variant="primary"
                    @click.prevent="searchData"
                    class="gobutton"
                    >Go!</b-button
                  >
                </div>
              </div>
            </div>
          </form>
  
          <div class="col-md-12 mt-3">
            <b-container fluid>
              <!-- User Interface controls -->
              <hr />
              <b-row>
                <b-col lg="4" class="my-1">
                  <b-form-group
                    label="Filter"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col lg="6" class="my-1">
                  <b-form-group
                    label="Filter On"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    description=""
                    class="mb-0"
                  >
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="package">
                        <small
                          ><strong>Package [OPG , CLS , PRI , PRG]</strong></small
                        ></b-form-checkbox
                      >
                      <b-form-checkbox value="member_type">
                        <small
                          ><strong>Type [STUDENT , STAFF , PUBLIC]</strong></small
                        ></b-form-checkbox
                      >
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col>
                  <div v-if="items != null">
                    Total Checkins: <b>{{ items.length }}</b> | Current Row Count:
                    <b>{{ totalRowCnt }}</b>
                  </div>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col sm="4" md="4" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </b-row>
  
              <!-- Main table element -->
              <b-table
                show-empty
                striped
                hover
                :items="items"
                :fields="fields"
                :tbody-tr-class="rowClass"
                :current-page="currentPage"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filterIncludedFields="filterOn"
                :busy="loading"
                v-model="visibleRows"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
  
                <template v-slot:cell(cardid)="row">
                  <a
                    v-if="row.item.member_id!=1"
                    href="#"
                    @click.prevent="
                      $router.push({
                        name: 'MemberHome',
                        params: { id: row.item.member_id },
                      })
                    "
                    >{{ row.item.member_cardid }}</a
                  >
                  <span v-else>{{ row.item.member_cardid }}</span>
                </template>
  
                <template v-slot:cell(package_detail)="row">
                  {{ row.item.package}}
                  <span v-if="row.item.note">
                    <b-button
                      class="btn-sm btn-light infobtnpackage"
                      :id="`popover-${row.item.id}`"
                      variant="primary"
                      ><i class="fas fa-info-circle infopackage"></i
                    ></b-button>
                    <b-popover
                      :target="`popover-${row.item.id}`"
                      triggers="hover focus"
                      :content="row.item.note"
                    ></b-popover>
                  </span>
                </template>
  
              </b-table>
            </b-container>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  import { getDateFormat } from "./../js/utils/date.js";
  import {
    packageTypeFull,
    packageDurationFull,
  } from "./../js/utils/datamanip.js";
  export default {
    data() {
      return {
        visibleRows: [],
        loading: false,
        items: null,
        start_date: new Date().toISOString().substring(0, 10),
        end_date: new Date().toISOString().substring(0, 10),
        fields: [
          {
            key: "cardid",
            label: "mem ID",
          },
          {
            key: "member_name",
            label: "Name",
          },
          {
            key: "member_type",
            label: "Type",
          },
          {
            key: "package_detail",
            label: "Package",
          },
          /*{
            key: "session",
            label: "Session",
          },*/
          {
            key: "member_email",
            label: "Email",
          },
          /*{
            key: "member_phone",
            label: "Phone",
          },*/
          {
            key: "checkin_at",
            label: "Check In",
            sortable: true,
          },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 1000,
        pageOptions: [1000, 2000],
        filter: null,
        filterOn: [],
        sortBy: "checkin_at",
        sortDesc: false,
        sortDirection: "asc",
      };
    },
    components: {
      DatePicker,
    },
    computed: {
      totalRowCnt() {
        return this.visibleRows.reduce((accum, item) => {
          return accum + 1;
        }, 0.0);
      },
      /*     start_date() {
        return getDateFormat(new Date());
      },
      end_date() {
        return getDateFormat(new Date());
      }, */
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return { text: f.label, value: f.key };
          });
      },
    },
    mounted() {},
    methods: {
      rowClass(item, type) {
        if (!item || type !== "row") return;
        if (item.status === "VOID") {
          return "table-danger";
        } else if (item.price_total == 0) {
          return "table-primary";
        }
      },
      itemClick(item, index, target) {},
      async searchData() {
        if (this.start_date !== null && this.end_date !== null) {
          this.loading = true;
          await axios
            .post("/api/members/checkinlist", {
              from: this.start_date,
              to: this.end_date,
            })
            .then((response) => {
              //console.log(response.data);
              this.items = response.data;
              this.totalRows = this.items.length;
              //console.log(response.data);
              this.loading = false;
            });
        }
      },
      getPackageTypeFull(key) {
        return packageTypeFull[key];
      },
      getPackageDurationFull(key) {
        return packageDurationFull[key];
      },
    },
  };
  </script>
  <style scoped>
  .gobutton {
    width: 80px;
    font-weight: bold;
  }
  table {
    font-size: 0.9em;
  }
  .voidtxt {
    color: #f00;
    text-decoration: line-through;
  }
  .infopackage {
    font-size: 1.5em;
    color: #007bff;
  }
  .infobtnpackage {
    padding: 0;
    background-color: transparent;
    border-color: transparent;
  }
  </style>
  